import { DigitalAssetsStorefrontAssetsListItemToggle } from "./digital-assets-storefront-assets-list-item-toggle";

export default props =>
  new DigitalAssetsStorefrontAssetsListItemToggle({
    eventSelector: ".js-digital-assets-storefront-assets-list-item-toggle",
    event: "change",
    ...props
  });
